import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

const FeedBackMetricTableHeaders = () => {
  return (
    <TableRow
      sx={{
        background: "#fff",
      }}
    >
      <TableCell>
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Topic
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Open
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Pending
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Replied
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Closed
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Number of users
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        >
          Number of google reviews
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography
          sx={{
            fontSize: "12px",
            color: "#0F2552",
          }}
        ></Typography>
      </TableCell>
    </TableRow>
  );
};

export default FeedBackMetricTableHeaders;
